// extracted by mini-css-extract-plugin
export default {"root":"FeaturedTag-root-e33fe611fa618fba23e84a4313049282"};